var v1="<div id=\"map-canvas\" style=\"height:200px\" ng-if=\"clubMapCtrl.mapOptions\" ui-map=\"::clubMapCtrl.myMap\" ui-options=\"::clubMapCtrl.mapOptions\" class=\"map\"></div>";
window.angular.module(["ng"]).run(["$templateCache",function(c){c.put("club/club-map/club-map.jade", v1)}]);
module.exports=v1;


//////////////////
// WEBPACK FOOTER
// ./ngapp/javascript/web/club/club-map/club-map.jade
// module id = 665
// module chunks = 0